<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <div class="filter__name">ID：</div>
        <el-input v-model="filters.arid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">标题：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn mr-10" @click="getList">搜索</button>
      <button class="blue-small-btn ml-auto" @click="editDialog = !editDialog">新建</button>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="600">
      <el-table-column prop="arid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="title" label="项目" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="预约链接" width="" align="center">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-document-copy" size="mini" class="copy-btn"
            @click="copyLink" :data-clipboard-text="scope.row.predict_upload_url"></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="quota" label="额度" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.mode == 0" >{{ scope.row.quota }}</div>
          <div v-if="scope.row.mode == 1" >{{ scope.row.quota }}单</div>
        </template>
      </el-table-column>
      <el-table-column prop="remain_quota" label="剩余额度" width="" align="center">
      </el-table-column>
      <el-table-column prop="sum_predict" label="总预约" width="" align="center">
      </el-table-column>
      <el-table-column prop="ocount" label="总预约数" width="" align="center">
      </el-table-column>
      <el-table-column prop="waiting_predict" label="待安排" width="" align="center">
      </el-table-column>
      <el-table-column prop="effect_predict" label="已安排" width="" align="center">
      </el-table-column>
      <el-table-column prop="invalid_predict" label="不安排" width="" align="center">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="" align="center">
        <template slot-scope="scope">
          <div class="flex jcc aic">
            <el-button type="primary" size="small" v-if="scope.row.status == 1" plain @click="changeInfo(scope.$index, 'status')">正常</el-button>
            <el-button type="info" size="small" v-if="scope.row.status == 0" plain @click="changeInfo(scope.$index, 'status')">失效</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <router-link class="blue-small-btn mr-10" :to="{path: '/adPredict', query: {arid: scope.row.arid}}">明细</router-link>
            <el-button type="primary" plain size="mini" @click="editInfo(scope.$index)">编辑</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="预约编辑" :visible.sync="editDialog" size="tiny" width="600px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">ID</div>
            <el-input v-model="detailInfo.arid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">标题:</div>
            <el-input v-model="detailInfo.title" placeholder="" size="mini" class="dataForm__input" :disabled="detailInfo.arid != 0"></el-input>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">限额方式</div>
            <el-radio-group v-model="detailInfo.mode">
              <div class="dib mr-20">
                <el-radio :label="0">按照金额</el-radio>
                <el-radio :label="1">按照单数</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">预约额度</div>
            <el-input v-model="detailInfo.quota" placeholder="" size="mini" class="dataForm__input">
              <template slot="append" v-if="detailInfo.mode === 0">￥</template>
              <template slot="append" v-if="detailInfo.mode === 1">单</template>
            </el-input>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">状态</div>
            <el-radio-group v-model="detailInfo.status">
              <div class="dib mr-20">
                <el-radio :label="0">下架</el-radio>
                <el-radio :label="1">运行</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="adRegisterEdit">保存</div>
          <div class="gray-large-btn" @click="editDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import Clipboard from 'clipboard'
import {adRegisterLists, adRegisterEdit} from '../../../api/api'
import util from '../../../script/util'
export default {
  name: 'adRegister',
  data () {
    return {
      opid: '',
      filters: {
        p: 1,
        l: 20,
        total: 0,
        arid: '',
        title: '',
        status: ''
      },
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '运行',
          value: 1
        },
        {
          name: '下架',
          value: 0
        }
      ],
      adLists: [],
      lists: [],
      listLoading: false,
      editDialog: false,
      detailInfo: {
        arid: 0,
        title: '',
        mode: 0,
        quota: '',
        status: 1
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    copyLink () {
      let clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', e => {
        this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success'
        })

        // 释放内存
        clipboard.destroy()
      })

      clipboard.on('error', e => {
        this.$notify({
          title: '失败',
          message: '复制失败',
          type: 'error'
        })

        // 释放内存
        clipboard.destroy()
      })
    },
    initInfo () {
      for (let key in this.detailInfo) {
        this.detailInfo[key] = ''
      }
      this.detailInfo.arid = 0
      this.detailInfo.mode = 0
      this.detailInfo.status = 1
    },
    editInfo (index) {
      this.editDialog = true
      for (let key in this.detailInfo) {
        this.detailInfo[key] = this.lists[index][key]
      }
    },
    saveInfo (params) {
      adRegisterEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.editDialog = false
          this.initInfo()

          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    changeInfo (index, key) {
      let arid = this.lists[index].arid

      let params = {
        arid: arid
      }

      if (key === 'status') {
        params['status'] = this.lists[index].status === 1 ? 0 : 1
      }

      this.saveInfo(params)
    },
    adRegisterEdit () {
      let params = util.cloneObj(this.detailInfo)

      let content = ''

      if (params['title'] === '') {
        content = '请填写用户'
      }

      if (params['quota'] === '') {
        content = '请填写额度'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      this.saveInfo(params)
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.arid !== '') {
        params.arid = filters.arid
      }

      if (filters.title !== '') {
        params.title = filters.title
      }

      if (filters.status !== '') {
        params.status = filters.status
      }

      this.listLoading = true
      adRegisterLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.arid': 'getList',
    'filters.title': 'getList',
    'filters.status': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adRegister.vue